import {AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, QueryList, ViewChildren} from "@angular/core";
import {SlideInAnimation, SlideOutAnimation} from "../../shared/utils/animations";
import {SectionItemsInterface} from "../../shared/interfaces/section-items.interface";
import {Router} from "@angular/router";
import {PACKAGES} from "../../shared/utils/utils";
import {PackageInterface} from "../../shared/interfaces/package.interface";
import {environment} from "../../../environments/environment";
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {Meta, Title} from "@angular/platform-browser";
import {PageUrlService} from "../../core/services/pageUrl.service";
import {AnalyticsService} from "../../core/services/analytics.service";

@Component({
  selector: "sw-packages",
  templateUrl: "./packages.component.html",
  animations: [SlideInAnimation, SlideOutAnimation]
})
export class PackagesComponent implements OnInit, AfterViewInit {
  @ViewChildren("packageItem") packageItems!: QueryList<ElementRef>;

  packages: SectionItemsInterface[] = [{
    header: "Grote schoonmaak",
    text: "In één keer je hele huis weer fris. Eén, twee of vier keer per jaar of gewoon elke maand. Dan heb je geen werkster meer nodig!",
    icon: "gs",
  }, {
    header: "Schoonmaak per uur",
    text: "Wij rijden voor en hebben de beste professionele middelen en materialen bij ons. Het enige wat we nodig hebben is water en stroom. Schoonmaakwoede gebruikt zoveel mogelijk milieuvriendelijke middelen. Want wij houden het milieu ook graag schoon!",
    icon: "ms",
  },
    {
      header: "Verbouw schoonmaak",
      text: "Verbouwen geeft troep. En bouwvakkers (en doe-het-zelvers) zijn nu eenmaal geen schoonmakers. Wij zijn dat wel!",
      icon: "rs",
    },
    {
      header: "Oplever schoonmaak",
      text: "Hét schoonmaakpakket om je huis schoon op te leveren. Makkelijk te bestellen, we hebben enkel je postcode en huisnummer nodig!",
      icon: "es",
    },
    {
      header: "Verhuis schoonmaak",
      text: "Laat je oude huis brandschoon achter of laat je nieuwe huis heerlijk fris maken. Nog mooier: Doe het allebei!",
      icon: "vs",
    }, {
      header: "Zwangerschap schoonmaak",
      text: "Een gezonde baby groeit op in een hygiënische omgeving. Onze schoonmaak zorgt voor een goede start!",
      icon: "zs",
    }];

  /** {
   header: "Voorjaars schoonmaak",
   text: "Je oma wist het al: het voorjaar vraagt om een schoon en fris huis. Zo ruik je het voorjaar buiten, maar ook binnen!",
   icon: "ls",
   },
   **/


  private observer!: IntersectionObserver;
  private currentIndex: number = 0;
  private isMobile: boolean = false;

  constructor(private router: Router,
              private title: Title,
              private meta: Meta,
              private analyticsService: AnalyticsService,
              private pageUrlService: PageUrlService,
              @Inject(PLATFORM_ID) private platformId: Object,
              @Inject(DOCUMENT) private document: Document) {
    if (isPlatformBrowser(this.platformId)) {
      this.observer = new IntersectionObserver(this.onIntersection, {threshold: 0.1});
    }
  }

  ngOnInit() {
    this.getTags();
  }


  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.trackInitialView();
      this.packageItems.forEach((item, index) => {
        if (this.isMobile && index >= 1) {
          this.observer.observe(item.nativeElement);
        } else if (!this.isMobile && index >= 3) {
          this.observer.observe(item.nativeElement);
        }
      });
    }
  }


  trackInitialView(): void {
    let initialPackages: any[] = [];
    if (this.isMobile) {
      initialPackages = this.packages.slice(0, 1).map((pkg, index) => (
        {
          item_id: "",
          item_name: pkg.header,
          index: index
        }));
    } else {
      initialPackages = this.packages.slice(0, 3).map((pkg, index) => ({
        item_id: "",
        item_name: pkg.header,
        index: index
      }));
    }
    this.analyticsService.trackViewItemList(initialPackages);
  }


  onIntersection = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target as HTMLElement;
        const index = this.packageItems.toArray().findIndex(item => item.nativeElement === element);
        if (index !== -1) {
          if (this.isMobile) {
            const pkg = this.packages.slice(index, index + 1).map((pkg, idx) => ({
              item_id: "",
              item_name: pkg.header,
              index: index + idx
            }));
            this.analyticsService.trackViewItemList(pkg);
          } else {
            const pkg = this.packages.slice(index, index + 3).map((pkg, idx) => ({
              item_id: "",
              item_name: pkg.header,
              index: index + idx
            }));
            this.analyticsService.trackViewItemList(pkg);
          }
          observer.unobserve(element); // Stop observing once the event is tracked
        }
      }
    });
  };

  onBtn1(item: SectionItemsInterface): void {
    if (isPlatformBrowser(this.platformId)) {
      const id = item?.icon as PackageInterface["packageId"];
      if (id === "es") {
        const url = `${environment.redirectUrl}/es/location?packageId=${item?.icon}`;
        this.document.location.href = url;
      } else {
        const url = `${environment.redirectUrl}location?packageId=${item?.icon}`;
        this.document.location.href = url;
      }
    }
  }

  onBtn2(item: SectionItemsInterface): void {
    if (isPlatformBrowser(this.platformId)) {
      const id = item?.icon as PackageInterface["packageId"];
      if (id === "ms") {
        this.router.navigate(["/schoonmaakdiensten/schoonmaak-per-uur",]);
      } else {
        const path = PACKAGES[id].replace(" ", "-");
        this.router.navigate(["/schoonmaakdiensten", path]);
      }
    }
  }

  getTags(): void {
    const pageUrl = this.pageUrlService.getPageUrl();
    this.title.setTitle("Schoonmaakwoede, alle schoonmaak diensten");
    const tags = [
      {
        name: "title",
        content: "Schoonmaakwoede, alle schoonmaak diensten. O.a. Grote Schoonmaak, Verbouw Schoonmaak, Verhuis Schoonmaak, Schoonmaak per uur en Maat Schoonmaak"
      },
      {
        name: "keywords",
        content: "Particulier schoonmaakbedrijf, schoonmaak voor de particulier, schoonmaakbedrijf voor woningen, schoonmaakbedrijf voor huizen, Grote schoonmaak, grote voorjaar schoonmaak, voorjaar schoonmaak,voorjaarsschoonmaak,verbouw schoonmaak, bouw schoonmaak, schoonmaak na verhuizing, huis schoonmaak, schoonmaak voor particulieren, verhuis schoonmaak,\n" +
          "schoonmaak bij verhuizing, schoonmaak na een feest, opruimen na een feest, verzamelwoede  schoonmaak,schoonmaakwoede, nesteldrang,mutatie schoonmaak,oplever schoonmaak,tapijtreinigen,ramen lappen,tapijtreinigend"
      },
      {
        name: "canonical",
        content: pageUrl
      },
      {
        name: "description",
        content: "Bekijk de particuliere schoonmaak diensten van Schoonmaakwoede voor uw huis. O.a. Grote Schoonmaak, Verbouw Schoonmaak, Verhuis Schoonmaak, Schoonmaak per uur en Maat Schoonmaak"
      },
      {
        name: "og:title",
        content: "Schoonmaakwoede, alle schoonmaak diensten. O.a. Grote Schoonmaak, Verbouw Schoonmaak, Verhuis Schoonmaak, Schoonmaak per uur en Maat Schoonmaak"
      },
      {
        name: "og:description",
        content: "Bekijk de particuliere schoonmaak diensten van Schoonmaakwoede voor uw huis. O.a. Grote Schoonmaak, Verbouw Schoonmaak, Verhuis Schoonmaak, Schoonmaak per uur en Maat Schoonmaak"

      },
      {
        name: "og:url",
        content: pageUrl
      },
      {
        name: "og:image",
        content: "" // ToDo: add image url
      },
      {
        name: "robots",
        content: "index, follow"
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0"
      },
      {
        charset: "UTF-8"
      },
    ];
    tags.forEach((tag: any) => this.meta.updateTag(tag));

  }
}
